import { useTreeState } from '../../../stores/Root'
import { IAudioStemStore } from '../../../stores/song/stem/AudioStemStore'
import { getStemColor } from '../../platform/color'

const useAudioStemTrack = (stemIndex: number) => {
  const { studio } = useTreeState()
  const song = studio.song
  const stem = song.stems[stemIndex] as IAudioStemStore
  const clips = stem.clips
  const studioBarsArray = Array.from(Array(song.songDisplayLength + studio.extraBarsCount).keys())
  const color = getStemColor(stem)

  return { studioBarsArray, color, clips }
}

export default useAudioStemTrack
